import { render, staticRenderFns } from "./NavPill.vue?vue&type=template&id=a0280d14&lang=pug&"
import script from "./NavPill.vue?vue&type=script&lang=js&"
export * from "./NavPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports